module.exports = __webpack_public_path__ + "img/qy-gz.72e4abd0.svg";